import {
  EventType,
  type InitMessage,
  type OfferReadyMessage,
  type PurchaseCompletedMessage,
  type OfferStateChangeMessage,
  type ReadyMessage,
  type ResizeMessage,
  type TokenizePaymentMessage,
  type UpdateMessage,
  type ValidateMessage,
  type EventInsuranceRequirementsStateChangeMessage,
  type EventExhibitorLiabilityStateChangeMessage,
  type ErrorMessage,
  type StateChangeMessage,
  type FilterOffersMessage,
  type FilterOffersResultMessage
} from "./types";

export const isInitMessage = (value: unknown): value is InitMessage => {
  return isEventTypeMessage(value, EventType.init);
}

export const isValidateMessage = (value: unknown): value is ValidateMessage => {
  return isEventTypeMessage(value, EventType.validate);
}

export const isReadyMessage = (value: unknown): value is ReadyMessage => {
  return isEventTypeMessage(value, EventType.ready);
}

export const isResizeMessage = (value: unknown): value is ResizeMessage => {
  return isEventTypeMessage(value, EventType.resize);
}

export const isOfferStateChangeMessage = (value: unknown): value is OfferStateChangeMessage => {
  return isEventTypeMessage(value, EventType.offer_state_change);
}

export const isPurchaseCompletedMessage = (value: unknown): value is PurchaseCompletedMessage => {
  return isEventTypeMessage(value, EventType.purchase_completed);
}

export const isStateChangeMessage = (value: unknown): value is StateChangeMessage => {
  return isEventTypeMessage(value, EventType.state_change);
}

export const isOfferReadyMessage = (value: unknown): value is OfferReadyMessage => {
  return isEventTypeMessage(value, EventType.offer_state_ready);
}

export const isTokenizePaymentMessage = (value: unknown): value is TokenizePaymentMessage => {
  return isEventTypeMessage(value, EventType.tokenize_payment);
}

export const isFilterOffersMessage = (value: unknown): value is FilterOffersMessage => {
  return isEventTypeMessage(value, EventType.filter_offers);
}

export const isFilterOffersResultMessage = (value: unknown): value is FilterOffersResultMessage => {
  return isEventTypeMessage(value, EventType.filter_offers_result);
}

export const isUpdateMessage = (value: unknown): value is UpdateMessage => {
  return isEventTypeMessage(value, EventType.update);
}

export const isEventInsuranceRequirementsStateChangeEvent = (value: unknown): value is EventInsuranceRequirementsStateChangeMessage => {
  return isEventTypeMessage(value, EventType.event_insurance_requirements_state_change);
}

export const isEventExhibitorLiabilityStateChangeMessage = (value: unknown): value is EventExhibitorLiabilityStateChangeMessage => {
  return isEventTypeMessage(value, EventType.event_exhibitor_liability_state_change);
}

export const isErrorMessage = (value: unknown): value is ErrorMessage => {
  return isEventTypeMessage(value, EventType.error);
}

const isEventTypeMessage = (value: unknown, eventType: EventType) => {
  return value != null && typeof value === "object" && 'eventType' in value && value.eventType === eventType;
}


/**
 * We don't need a cryptographically secure UUID for this use case, so we can use a simple implementation.
 * @returns A random UUIDv4 string.
 */
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
